/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Time_Not_SetInputs */

const en_colleague_time_not_set = /** @type {(inputs: Colleague_Time_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set`)
};

const ja_colleague_time_not_set = /** @type {(inputs: Colleague_Time_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未設定`)
};

const fr_colleague_time_not_set = /** @type {(inputs: Colleague_Time_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non défini`)
};

const de_colleague_time_not_set = /** @type {(inputs: Colleague_Time_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gesetzt`)
};

/**
* | output |
* | --- |
* | "Not set" |
*
* @param {Colleague_Time_Not_SetInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_time_not_set = /** @type {((inputs?: Colleague_Time_Not_SetInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Time_Not_SetInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_time_not_set(inputs)
	if (locale === "ja") return ja_colleague_time_not_set(inputs)
	if (locale === "fr") return fr_colleague_time_not_set(inputs)
	return de_colleague_time_not_set(inputs)
});